import React, { useState, useRef, useEffect } from "react";

const SignatureCanvas = ({ onSave, savedSignature }) => {
  const canvasRef = useRef(null);
  const [isDrawing, setIsDrawing] = useState(false);
  const [isEnabled, setIsEnabled] = useState(false);
  const [context, setContext] = useState(null);
  const [signatureData, setSignatureData] = useState(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');
    // setContext(ctx);

    // // Clear canvas first
    // ctx.fillStyle = "white";
    // ctx.fillRect(0, 0, canvas.width, canvas.height);

    // If in OFF mode and we have a saved signature, show it
    if (!isEnabled && savedSignature) {
      const img = new Image();
      img.crossOrigin = "anonymous";
      img.src = savedSignature;
      img.onload = () => {
        // First clear
        ctx.fillStyle = "white";
        ctx.fillRect(0, 0, canvas.width, canvas.height);
        // Then draw saved signature
        ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
      };
    }
  }, [isEnabled, savedSignature]); // Add isEnabled to dependencies


  const handleClearSignature = () => {
    if (!isEnabled) return;
    const ctx = canvasRef.current.getContext("2d");
        ctx.clearRect(0, 0, canvasRef.current.width, canvasRef.current.height);
        setSignatureData(null);
  };

  const handleToggle = () => {
    const newEnabled = !isEnabled;
    setIsEnabled(newEnabled);

    if (context) {
      if (newEnabled) {
        context.fillStyle = "white";
        context.fillRect(0, 0, canvasRef.current.width, canvasRef.current.height);
      } else {
        // When switching from ON to OFF, show saved signature if it exists
        if (savedSignature) {
          const img = new Image();
          img.crossOrigin = "anonymous";
          img.src = savedSignature;
          img.onload = () => {
            // First clear
            context.fillStyle = "white";
            context.fillRect(0, 0, canvasRef.current.width, canvasRef.current.height);
            // Then draw saved signature
            context.drawImage(img, 0, 0, canvasRef.current.width, canvasRef.current.height);
          };
        }
      }
    }
  };

  const handleMouseDown = (e) => {
    if (!isEnabled) return;
    setIsDrawing(true);
    const ctx = canvasRef.current.getContext("2d");
    ctx.beginPath();

    const canvasPosition = canvasRef.current.getBoundingClientRect();
    ctx.moveTo(e.clientX - canvasPosition.left, e.clientY - canvasPosition.top);
};

const handleMouseMove = (e) => {
    if (!isDrawing || !isEnabled) return;

    const ctx = canvasRef.current.getContext("2d");
    const canvasPosition = canvasRef.current.getBoundingClientRect();
    ctx.lineTo(e.clientX - canvasPosition.left, e.clientY - canvasPosition.top);
    ctx.stroke();
};

const handleMouseUp = () => {
  if(!isEnabled) return;
    setIsDrawing(false);

    const canvas = canvasRef.current;
    const dataURL = canvas.toDataURL("image/png");
    onSave(dataURL);
};

  return (
    <div className="signature form-group mt-4" style={{ width: "auto !important" }} >
      <div
        className={`toggle-switch ${isEnabled ? "switch-on" : "switch-off"}`}
        onClick={handleToggle}
      >
        <span className="switch-label"></span>
        <div className="knob"></div>
        <span className="switch-label"></span>
      </div>

      <div
        style={{
          touchAction: 'none',
          userSelect: 'none',
          WebkitUserSelect: 'none',
          position: 'relative',
          overflowX: 'scroll',
        }}
        onTouchStart={(e) => e.preventDefault()}
        onTouchMove={(e) => e.preventDefault()}
      >
        <canvas
          ref={canvasRef}
          width={600}
          height={200}
          style={{
            border: "1px solid black",
            cursor: isEnabled ? "crosshair" : "not-allowed",
            marginTop: "10px",
            backgroundColor: "white",
            opacity: isEnabled ? 1 : 0.5,
            display: "block"
          }}
          onMouseDown={handleMouseDown}
          onMouseMove={handleMouseMove}
          onMouseUp={handleMouseUp}
          onMouseLeave={handleMouseUp}
        />
      </div>

      <div style={{ marginTop: "10px" }}>
        <button
          type="button"
          onClick={handleClearSignature}
          className="canvasign btn btn-secondary"
          disabled={!isEnabled}
        >
          Clear Signature
        </button>
      </div>

      <style>
        {`
          .toggle-switch {
            display: flex;
            align-items: center;
            justify-content: space-between;
            width: 70px;
            height: 30px;
            border-radius: 20px;
            font-weight: bold;
            cursor: pointer;
            user-select: none;
            transition: background 0.3s ease-in-out;
            position: relative;
            background-color: #dc3545;
            padding: 5px;
          }

          .switch-on {
            background-color: #28a745;
          }

          .switch-label {
            font-size: 12px;
            color: white;
            flex: 1;
            text-align: center;
          }

          .knob {
            position: absolute;
            top: 2px;
            width: 26px;
            height: 26px;
            background: white;
            border-radius: 50%;
            transition: transform 0.3s ease-in-out;
          }

          .switch-on .knob {
            transform: translateX(40px);
          }

          .switch-off .knob {
            transform: translateX(2px);
          }
        `}
      </style>
    </div>
  );
};

export default SignatureCanvas;